import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";

export const book_info: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <g stroke="currentcolor" strokeWidth="1" fill="none">
        {/* <path
        fill="none"
        fillRule="evenodd"
        stroke="currentcolor"
        strokeWidth="1"
        d="M4.5,18.4997 L4.5,5.4997 C4.5,4.3957 5.396,3.4997 6.5,3.4997 L19.5,3.4997 L19.5,16.5017 L6.5,16.5017 C5.396,16.5017 4.5,17.3957 4.5,18.4997 C4.5,19.6037 5.396,20.5017 6.5,20.5017 L20,20.4997 M7,18.4997 L20,18.4997 M13.5,10.0002 C13.5,10.8282 12.829,11.5002 12,11.5002 C11.171,11.5002 10.5,10.8282 10.5,10.0002 C10.5,9.1712 11.171,8.5002 12,8.5002 C12.829,8.5002 13.5,9.1712 13.5,10.0002 Z M12,8.5002 C11.171,8.5002 10.5,7.8282 10.5,7.0002 C10.5,6.1712 11.171,5.5002 12,5.5002 C12.829,5.5002 13.5,6.1712 13.5,7.0002 M12,11.5002 C12.829,11.5002 13.5,12.1712 13.5,13.0002 C13.5,13.8292 12.829,14.5002 12,14.5002 C11.171,14.5002 10.5,13.8292 10.5,13.0002"
      /> */}
        <path d="M 6.4097891,16.770632 C 5,16.5 4,16.5 2.5,16.5 L 2.5,1.5 c 5.5,0 8,0.5 10,3 C 14.5,2 16.5,1.5 21.5,1.5 v 15 c -0.953538,-0.01112 -2,0 -3.007027,0.240561" />
        <path d="M 12.5,4.5 V 11.5" />
        <circle cx="12.5" cy="17.5" r="6" />
        <path d="m 21.5,4 c 0,0 1.312973,-0.073648 2,10e-8 V 19 C 22,18.5 20,18.5 18.5,18.5" />
        <path d="M 2.4699297,2.8272597 C 2.4699297,2.8272597 1.5,2.5 0.5,2.5 c 0,0 0,11 0,16.5 C 2.5,18.5 4.5,18.5 6.5,18.5" />
        <path d="M 13.982672,5.8937714 C 15,4.5 17.5,3.5 19.5,3.5" />
        <path d="M 14,8.9999998 C 15.017328,7.6062282 17.5,6.5 19.5,6.5" />
        <path d="m 14.5,11.5 c 1.137609,-1.123139 3,-2 5,-2" />
        <path d="M 16.869417,13.209836 C 17.736394,12.778314 18.5,12.5 19.5,12.5" />
        <path d="M 10.017328,5.8937711 C 9,4.5 6.5,3.5 4.5,3.5" />
        <path d="m 10,9 c -1.017328,-1.393772 -3.5,-2.5 -5.5,-2.5" />
        <path d="m 9.5,11.5 c -1.137609,-1.123139 -3,-2 -5,-2" />
        <path d="M 7.1305829,13.209836 C 6.2636059,12.778314 5.5,12.5 4.5,12.5" />
        <path d="m 11,20.5 h 3" />
        <path d="m 11.5,16.5 h 1 l 0,4" />
      </g>
      <circle cy="14" cx="12.5" r="1.0" fill="currentcolor" stroke="none" />
    </svg>
  );
};
